import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-movebuttons-column-renderer',
  template: `
    <button class="btn btn-link" style="padding: 0; margin-right: 15px;" (click)="move(true)">
      <i class="fa fa-arrow-up"></i> Move Up
    </button>
    <button class="btn btn-link" style="padding: 0;" (click)="move(false)">
      <i class="fa fa-arrow-down"></i> Move Down
    </button>
  `,
  standalone: false
})
export class MoveButtonsColumnRendererComponent implements AgRendererComponent {
  private params: any

  agInit(params: any): void {
    this.params = params
  }

  refresh(params: any): boolean {
    return false
  }

  move(moveUp: boolean): void {
    if (this.params.context.moveHandler) {
      this.params.context.moveHandler(this.params.data, moveUp)
    }
  }
}
